export default "__VITE_ASSET__B56GAh9q__"